// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  encounterId: __t.u64().name("encounter_id"),
  pulseIndex: __t.u32().name("pulse_index"),
  heroId: __t.u64().name("hero_id"),
  slot: __t.u8(),
  action: __t.u16(),
  intent: __t.byteArray(),
  snapshotHash: __t.byteArray().name("snapshot_hash"),
  revision: __t.u32(),
  committed: __t.bool(),
  substituted: __t.bool(),
  owner: __t.identity(),
  updatedAt: __t.timestamp().name("updated_at"),
});
